import { englishMessages } from './common';

export default {
  ...englishMessages,
  'footnotes.nedc':
    'The figures shown were obtained in accordance with the prescribed measuring process. They are "NEDC CO2 values" pursuant to Art. 2 No. 1 of Implementing Regulation (EU) 2017/1153. The fuel consumption figures have been calculated on the basis of these values. Electrical consumption has been determined on the basis of Directive 692/2008/EC.',
};
